import { TFunction } from "i18next";
import * as Yup from "yup";

import { nullableAmount, nullableDate, nullableText } from "../../utils/validation.utils";
import {
  PropertyRightFormValue,
  PropertyRightsFormValues,
  PropertyRightsMaxLength,
} from "./OtherPropertyRightsView.types";
import { hasRightsOf } from "./OtherPropertyRightsView.utils";

export function createPropertyRightsSchema(t: TFunction) {
  const unchecked = () => Yup.mixed().nullable();

  const rightSchema = (right: PropertyRightFormValue) => {
    const isAmountKnown = right.expectsProceeds === true && right.isProceedsAmountKnown === true;

    return Yup.object().shape({
      landlord: nullableText(t, PropertyRightsMaxLength.landlord),
      propertyDetails: nullableText(t, PropertyRightsMaxLength.text),
      proceedsAmount: isAmountKnown ? nullableAmount(t) : unchecked(),
      proceedsDate: isAmountKnown ? nullableDate(t) : unchecked(),
      remarks: nullableText(t, PropertyRightsMaxLength.text),
      details: nullableText(t, PropertyRightsMaxLength.text),
    });
  };

  return Yup.lazy(({ answers }: PropertyRightsFormValues) =>
    Yup.object().shape({
      answers: Yup.object().shape({
        tenantOrOwnerOfHomeAddress: nullableText(t, PropertyRightsMaxLength.tenantOrOwner),
      }),
      propertyRights: Yup.array().of(
        Yup.lazy((right: PropertyRightFormValue) =>
          hasRightsOf(answers, right.kind) ? rightSchema(right) : unchecked()
        )
      ),
    })
  );
}
